module.exports = __webpack_public_path__ + "assets/img/zqb.178c86fe.png";